import React from 'react';

interface AvailabilityCalendarProps {
  availability: number[][];
}

const AvailabilityCalendar: React.FC<AvailabilityCalendarProps> = ({ availability }) => {
  const daysOfWeek = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
  const hours = ['Mañana', 'Tarde', 'Noche'];

  return (
    <div className="w-full">
      <div className="grid grid-cols-7 gap-2">
        {daysOfWeek.map((day) => (
          <div key={day} className="text-center font-semibold">
            {day}
          </div>
        ))}
        {availability.map((day, dayIndex) => (
          <div key={dayIndex} className="flex flex-col gap-1">
            {hours.map((_, hourIndex) => {
              const startHour = hourIndex * 8;
              const endHour = startHour + 7;
              const isAvailable = day.slice(startHour, endHour + 1).some(slot => slot === 1);
              return (
                <div
                  key={hourIndex}
                  className={`w-full h-8 rounded-lg ${
                    isAvailable ? 'bg-green-500' : 'bg-gray-300'
                  }`}
                  title={`${hours[hourIndex]}: ${isAvailable ? 'Disponible' : 'No disponible'}`}
                ></div>
              );
            })}
          </div>
        ))}
      </div>
      <div className="mt-4 flex justify-center gap-4">
        {hours.map((hour, index) => (
          <div key={index} className="flex items-center">
            <div className={`w-4 h-4 rounded-sm mr-2 ${index === 0 ? 'bg-green-500' : 'bg-gray-300'}`}></div>
            <span className="text-sm">{hour}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AvailabilityCalendar;
